export default "__VITE_ASSET__VAG5l1_B__"